import { atom } from "recoil"

import { BlacklistChattingRole } from "../enums/blackListChattingRole"

export const blacklistStatusState = atom({
  key: "blacklistStatusState",
  default: {
    [BlacklistChattingRole.USER]: false,
    [BlacklistChattingRole.FREE_USER]: false,
    [BlacklistChattingRole.PAID_USER]: false,
    [BlacklistChattingRole.NOT_MATCHED_USER]: false,
    [BlacklistChattingRole.OTHER_PAID_USER]: false,
  },
})
